const translations = {
  name: 'Nome',
  slaType: 'Tipo SLA',
  duration: 'Duração',
  slaUnit: 'Unidade SLA',
  checklists: 'Questionários',
  places: 'Locais',
  createdAt: 'Criado em',
  emptyMessage: 'Nenhum dado encontrado',
  'slaUnits.day': 'Dias',
  'slaUnits.hour': 'Horas',
  'slaUnits.minute': 'Minutos',
  'slaTypes.creationDate': 'Data de abertura',
  'slaTypes.schedulingDate': 'Data de agendamento',
  'header.title': 'Configurações de SLA',
  'header.subtitle': 'Gerencie as configurações de SLA do sistema: visualize, crie ou edite conforme necessário.',
  'header.newConfig': 'Nova configuração',
  'modal.listTitle': 'Configurações de SLA',
  'modal.editTitle': 'Editar SLA',
  'modal.newTitle': 'Novo SLA'
}

export default translations
